import { MY_MEETINGS } from './meetings';

export const CASE_CAVE_TITLE = 'Case Cave';

export const TICKETING_SYSTEM_ALLOWLIST = {
    PROD: [
        9077,
        105942,
        441306,
        1411921,
        1411922,
        1411925,
        1412312,
        1412320,
        2077762,
        2429620,
        3565164,
        3606400,
        3714255,
        8791274,
        8791395,
        8893141,
        8893146,
        9369078,
    ],
    ALPHA: [6203610],
    QA: [2062446],
    DEV: [2062446],
};

export const ALLOWED_BROWSERS = [
    { label: 'Chrome', value: 'chrome' },
    { label: 'Edge', value: 'edge' },
    { label: 'Firefox', value: 'firefox' },
    { label: 'Internet Explorer', value: 'internet_explorer' },
    { label: 'Safari', value: 'safari' },
    { label: 'Other', value: 'other' },
];

export const MY_CASES = {
    label: 'My Cases',
    value: 'myCases',
    noData: 'You have not submitted any cases yet.',
    BUTTONS: {
        VIEW: 'View',
    },
    SEARCH_PLACEHOLDER: {
        PARTNER: 'Search by Question, Client, or Case No.',
        CLIENT: 'Search by Question or Case No.',
    },
    path: '/my-cases',
    WAITING_FOR_CLIENT_TOOLTIP: 'Waiting for client followup.',
};

export const CASE_STATUS_TYPES = {
    WAITING_FOR_CLIENT: 'waiting_for_client',
};

export const CLIENT_CASES = {
    label: 'Client Cases',
    value: 'clientCases',
    noData: 'No cases have been submitted on behalf of Clients yet.',
    path: '/my-cases/client-cases',
};

export const MY_MESSAGES = {
    label: 'My Messages',
    NO_DATA: 'You do not have any messages yet.',
    NO_SEARCH_RESULTS: 'No matching messages found.',
    path: '/my-cases/my-messages',
    SEARCH_PLACEHOLDER: 'Search by Case No., Client, or From',
    value: 'myMessages',
    TITLE: 'Messages',
};

export const TECHNICAL_SUPPORT = {
    LABEL: 'Technical Support',
};

export const INCLUDED_TYPES = {
    CASE_TYPES: 'case_types',
    CASE_STATUSES: 'case_statuses',
    CASE_WORKERS: 'case_workers',
    CONTENT_SUMMARY_LINKS: 'content_summary_links',
    MESSAGES: 'messages',
    SOURCES: 'ticket_sources',
    TASKS: 'tasks',
    TASK_TYPES: 'task_types',
    TICKETS: 'tickets',
    TOPICS: 'topics',
    USERS: 'users',
    EXPERT_MEETINGS: 'expert_meetings',
};

export const NO_SEARCH_RESULTS = 'No matching cases found.';

export const ASK_AN_EXPERT = 'Ask an Expert';

export const TICKET_STATUSES = {
    PENDING: 'Pending Assignment',
    RESEARCHING: 'Researching',
    ANSWERED: 'Answered',
};

export const TICKET_TYPES = {
    ALL: 'all',
    TECH_SUPPORT: 'technical_support',
    LEARN_CONSULT: 'learn_consult',
    DOCUMENT: 'document',
    ADVICE: 'atp',
    COMPLETE: 'complete',
    POLICY: 'policy',
};

export const GREETING = 'What is your question?';

export const BUTTONS = {
    FOLLOW_UP: 'ASK FOLLOW-UP QUESTION',
    SUBMIT: 'SUBMIT',
    COMMENTS: {
        SAVE: 'Save',
        NOTHING: 'Nothing to save',
    },
};

export const COMMENTS = {
    ERROR: {
        CREATE: 'Error creating comment',
        UPDATE: 'Error updating comment',
    },
    NO_COMMENTS: 'No Comments',
    EDITED_BY_TEXT: 'Edited by',
    EDIT_TITLE: 'Edit Comment',
};

export const RESOURCES = {
    BUTTONS: {
        ADD: 'Add Resource',
        EDIT: 'Edit Resources',
        LINK: 'Link',
    },
    SUCCESS: {
        CREATE: 'Success adding resource',
        UPDATE: 'Success updating resource',
        DELETE: 'Success deleting the resource',
    },
    ERROR: {
        CREATE: 'Error creating resource',
        UPDATE: 'Error updating resource',
        INVALID_URL: 'Invalid url',
    },
    NO_RESOURCES: 'No Resources',
};

export const NOMINATE_FOR_VPA = {
    TITLE: 'Why should this be a vetted prepped answer?',
    ERROR: {
        CREATE: 'Error nominating prepped answer',
        UPDATE: 'Error updating prepped answer',
    },
    SUCCESS: 'Success nominating prepped answer',
    BUTTONS: {
        SAVE: 'Save',
        NOTHING: 'Nothing to save',
    },
};

export const FOLLOW_UP = {
    TITLE: 'Thank you for your question!',
    CONFIRMATION:
        'Our team will start working on it shortly and you will receive an email notification once your response is ready to view.',
    REFERENCE: 'For reference, your case number is:',
};

export const USER_LOOKUP = {
    TITLE: 'User Lookup',
    PARTNER_FILTER_TITLE: 'PARTNER FILTER',
    CLIENT_FILTER_TITLE: 'CLIENT FILTER',
    USER_DETAIL_TITLE: 'Products Available to Client',
    CASES: {
        TOTAL: 'Total cases submitted:',
        LAST_90: 'Cases submitted in the last 90 days:',
        CASE_COUNTS: '${openCaseCount}/${submittedCaseCount}',
    },
    NO_FILTERED_SKUS: 'No SKUs Found',
    NO_DATA: 'No Users Found',
    NO_SEARCH: 'Enter search terms or select filters to see a list of results.',
    TOOLTIPS: {
        NAME: 'ID: ${userId}',
        LAST_SIGN_IN: 'Last Signin: ${lastSignIn}',
        EMAIL: 'Username: ${userName}',
        PARTNER: 'Partner ID: ${partnerId}',
        OPEN_CASES: 'Total Cases Submitted: ${submittedCaseCount}',
        SHOW_DETAILS: 'Show Additional Details for this Client',
        EDIT_USER: 'Edit User Details',
        CREATE_CASE: 'Create Case',
    },
};

export const PARTNER_LABEL = 'PARTNER';

export const COMPANY_LABEL = 'COMPANY';

export const ASSIGNMENTS = {
    ROLES: [
        'System Administrator',
        'Genesis Admin',
        'Genesis Employee',
        'Content Author',
        'HR Pro',
        'Frontline Coordinator',
        'Independent Contractor',
    ],
    DEPARTMENT_NAMES: [
        'Customer Support',
        'customer support',
        'Advisory Services',
        'advisory services',
        'EOC',
    ],
    LIST_IDS: [
        'atp',
        'complete',
        'technical_support',
        'document',
        'prep',
        'answer',
        'review',
        'openTasks',
        'dailyCompletions',
    ],
    LABEL: 'Assignments',
    CUSTOMER_SUPPORT: {
        label: 'Customer Support',
        value: 'customer support',
    },
    ADVISORY_SERVICES: {
        label: 'Advisory Services',
        value: 'advisory services',
    },
    OTHER: {
        label: 'Other',
        value: 'other',
    },
    OTHER_CTA:
        'Users in this tab have a Department other than Customer Support or Advisory Services. Department settings can be viewed and edited in System Administration, under the Users section.',
    ERROR: 'Error fetching assignments',
};

export const USER_DETAILS_MODAL = {
    TITLES: {
        CASES: 'Cases',
        SKUS: 'Active SKUs',
        CONFIGURATIONS: 'Configurations',
        EHS_CONTENT: 'EHS Content',
    },
    PLACEHOLDERS: {
        SKUS: 'Filter by Name',
        CONFIGURATIONS: 'Filter by Name, Description, or Type',
        EHS_CONTENT: 'Search by name',
    },
    EHS_PRODUCTS: {
        ACTIVE_PACKAGES: 'Active Packages',
        ACTIVE_SKU: 'Active SKUs',
    },
    NO_SEARCH_RESULTS: 'No matching messages found.',
};

export const DASHBOARD_MY_CASES = {
    LINK: 'Take Me To My Cases',
};

export const UNIDENTIFIED_CASES = {
    TITLE: 'Unknown Tickets',
    CASE_CAVE_TITLE: 'Unknown Cases',
    STATUSES: {
        OPEN: 'open',
        RESPONDED: 'responded',
        CANCELLED: 'cancelled',
    },
    BULK_ACTIONS: {
        LABEL: 'Bulk Actions',
        CANCEL: {
            ID: 'bulkCancelUnknownCases',
            MODAL_CLOSE: 'Close',
            MODAL_CONFIRM: 'Confirm',
            MODAL_DESCRIPTION_SINGULAR:
                'Are you sure you would like to bulk cancel this Unknown Case? This action cannot be undone.',
            MODAL_DESCRIPTION:
                'Are you sure you would like to bulk cancel these ${QUANTITY_TO_DELETE} Unknown Cases? This action cannot be undone.',
            MODAL_TITLE: 'Bulk Cancel Cases',
            TITLE: 'Cancel Unknown Cases',
        },
    },
    CANCEL: {
        BUTTONS: {
            EXIT: 'Exit',
            CONFIRM: 'Confirm',
        },
        TITLE: 'Cancel Case #',
        DESCRIPTION: 'Are you sure? This action cannot be undone.',
    },
    RESPOND: {
        TITLE: 'Respond To Case',
        CONFIRMATION_TITLE: 'Confirm Response to Case #',
        CONFIRMATION_DESCRIPTION: 'Are you sure you want to send this response?',
        NO_SUBJECT: 'No Subject #',
        BUTTONS: {
            CONFIRM: 'Confirm',
            BACK: 'Back',
            SEND: 'Send',
        },
    },
    EDIT: {
        TITLE: 'Editing Case',
        BUTTONS: {
            SAVE: 'Save',
        },
    },
    CONVERT: {
        TITLE: 'Convert to Case',
        TITLE_TICKET: 'Convert to Ticket',
        LABEL: 'Select a User',
        PLACEHOLDER: 'Search by Name, Email, Company, Username, Job Title, Phone',
        BUTTONS: {
            CREATE: 'Create Case',
        },
    },
    ERROR: {
        EMAIL: 'Email cannot be blank.',
    },
};

export const CASE_SUMMARY = {
    TITLE: 'CASE SUMMARY',
    TYPE: 'Type',
    TOPIC: 'Topic',
    STATES: 'States (Employees)',
    SUBMITTED_BY: 'Submitted By',
    SUBMITTED_BY_PARTNER: 'Partner User Who Submitted Case',
    PARTNER_USER_NAME: 'Partner User Name',
    SUBMITTED_FOR: 'Submitted For',
    CLIENT_USER_NAME: 'Client User Name',
    SUBMITTED_ON: 'Submitted On',
    CLOSED: 'Closed',
    STATUS: 'Status',
    LEGACY_CASE: 'Legacy Case',
};

export const LINK_SUMMARY = {
    TITLE: 'LINKS',
    PRIOR_QUESTION: 'Prior Question',
    DOWNLOAD_ATTACHMENTS: 'Response Attachments',
    CONTENT_LINKS: 'Content Links',
    MY_ATTACHMENTS: 'My Attachments',
    ADD_ATTACHMENTS: 'Add Attachments',
    TECHNICAL_SUPPORT: 'technical_support',
    STATUS_CLOSED: 'closed',
};

export const MY_CASE_DETAILS = {
    TITLE: 'My Case Details',
    STATUS: 'STATUS:',
    CASE: 'Case #:',
    QUESTION: 'Question:',
    ANSWERED_BY: 'Answered By:',
    ANSWER: 'Answer:',
    ERROR: {
        STATUS: {
            NOT_FOUND: 'Request failed with status code 404',
        },
        MESSAGE: {
            NOT_FOUND: 'Please contact us for assistance.',
            NO_MNL_EXPERTS_SKU: 'To view this case, you need HR Experts.',
            CASE_NOT_AVAILABLE:
                'This case is no longer available. Please contact us for assistance.',
        },
    },
    DOWNLOAD_TEMPLATE: {
        TITLE: 'Case Summary: Case #${CASE_ID}',
        FILE_NAME: 'Case-#${CASE_ID}.pdf',
        PRINT_FILE_NAME: 'Mineral Case #${CASE_ID}',
    },
    MESSAGES: {
        TITLE: 'MESSAGES',
        DATE_CREATED: 'Date Message Created',
        TYPE: 'Message Type',
        FROM: 'From',
        BODY: 'Message',
    },
    ATTACHMENT: {
        DELETE: 'Delete',
    },
};

export const CASE_LIMIT = {
    ATTACHMENT_MAX_FILE_SIZE: 5242880,
    ATTACHMENT_MAX_FILE_SIZE_IN_MB: 5,
    ATTACHMENT_MAX_FILE_COUNT: 15,
};

export const VPA_REQUEST = {
    label: 'VPA Suggestions',
};

export const VPA_QUEUE = {
    label: 'Queue',
    value: 'queue',
    noData: 'No VPA submitted yet',
    BUTTONS: {
        VIEW: 'View',
        QUICK_EDIT: 'Quick Edit',
    },
};

export const VPA_CANCELLED = {
    label: 'Cancelled',
    value: 'cancelled',
    noData: 'No VPA submitted yet',
};

export const VPA_COMPLETED = {
    label: 'Completed',
    value: 'completed',
    noData: 'No VPA submitted yet',
};
export const PENDO_CLASSNAME = 'pendo-my-classes';

export const SATISFACTION_SURVEY = {
    TITLE: 'Satisfaction Survey',
    QUESTIONS: [
        {
            label: 'My case was handled to my satisfaction',
            key: 'handling',
        },
        { label: 'I would recommend your service to others', key: 'recommendation' },
        { label: 'The Expert understood my issue', key: 'understanding' },
        { label: 'The response was clear and easy to understand', key: 'response' },
        { label: 'Overall experience on this case', key: 'experience' },
    ],
    COMMENTS_LABEL: 'Comments',
    SUBMIT: {
        SUCCESS: 'Thanks for your feedback!',
    },
};

export const MY_CASES_ROUTES = [
    { path: '/my-cases', label: 'My Cases' },
    { path: '/my-cases/client-cases', label: 'Client Cases' },
    { path: '/my-cases/create', label: 'Ask an Expert' },
    { path: '/my-cases/client-cases/create', label: 'Ask an Expert' },
    { path: '/my-cases/:id/details', label: 'My Case Details' },
    { path: '/my-cases/client-cases/:id/details', label: 'My Case Details' },
    { path: '/my-cases/my-messages', label: MY_MESSAGES.label },
    { path: '/my-cases/my-meetings', label: MY_MEETINGS.label },
    { path: '/my-cases/create-technical-support', label: 'Technical Support' },
];

export const TRANSFER_CASES = {
    TITLE: 'Transfer Cases',
    INSTRUCTION: 'This tool will transfer all cases from one client to another.',
    NOTE:
        'Please Note: If the client has a large number of cases, it may take a few minutes for all of the cases to be visible to them.',
    BUTTONS: {
        SAVE: 'Save',
    },
    SUBMIT: {
        SUCCESS: '${caseCount} Cases have successfully been transferred to ${toUserName}',
    },
    FIELDS: {
        ACTIVE_SKU: 'Active SKUs',
        CONFIGURATIONS: 'Configurations',
    },
    TRANSFER_CASE_CARD_ITEM_LABEL: {
        NAME: 'Name',
        CLIENT_COMPANY: 'Client Company',
        PARTNER_COMPANY: 'Partner Company',
        EMAIL_ID: 'Email Id',
        PHONE_NO: 'Phone No',
        USER_STATUS: 'User Status',
        DEDICATED_HR_EXPERT: 'Dedicated HR Expert',
        CASE_COUNT: 'Case Count (Last 90 days)',
        OVERALL_CASE_COUNT: 'Overall Case Count',
    },
    TRANSFER_CASE_MENU_ITEM_LABEL: {
        VIEW_ALL_PRODUCTS: 'View All Products ',
    },
    ALL_PRODUCTS_MODAL: {
        TITLE: 'Products available to client',
    },
    INACTIVE: 'Inactive',
};

export const PREPPED_ANSWERS = {
    TITLE: 'Prepped Answers',
    CANCEL: 'Are you sure you want to cancel this Prepped Answer?',
    ANSWERS_TABS: {
        label: 'Prepped Answers',
        value: 'prepped_answers',
        noData: 'No Prepped Answers Submitted',
    },
    MY_FAVORITE_TABS: {
        label: 'My Favorites',
        value: 'my_favorites',
        noData: 'No Prepped Answers Submitted',
    },
    DETAILS: {
        ID: 'Prepped Answer #',
        TITLE: 'Title',
        ANSWER: 'Answer',
        BUTTONS: {
            EDIT: 'EDIT',
            DELETE: 'DELETE',
        },
        ACTIONS: {
            LABEL: 'Actions',
            PRIORITIZE: 'Prioritize',
            DECLINE: 'Decline',
            COMPLETE: 'Complete',
            DOWNGRADE: 'Downgrade',
        },
        PA_SUMMARY: {
            AUTHOR: 'Author',
            TITLE: 'PREPPED ANSWER SUMMARY',
            TOPICS: 'Topics',
            STATES: 'States',
            KEY_PHRASES: 'Key Phrases',
            KIND: 'Kind',
            UPDATED: 'Updated at',
            CREATED: 'Created at',
        },
        LINK_SUMMARY: {
            TITLE: 'LINKS',
            CONTENT_LINKS: 'Content Links',
        },
        MENU_ITEMS: {
            CLONE: 'Clone',
            NOMINATE_FOR_VPA: 'Nominate For VPA',
            NOMINATED_FOR_VPA: 'Nominated For VPA',
            SUGGEST_UPDATE: 'Suggest Update',
            NOMINATE_KEY: 'regular',
            NOMINATED_KEY: 'pending',
            APPROVED_NOMINATED_KEY: 'vpa',
        },
        MODALS: {
            NOMINATE_MODAL: {
                TITLE: 'Nominate for VPA',
            },
            RESOURCES_MODAL: {
                TITLE: 'Resources',
            },
            PREPPED_ANSWERS_HISTORY_MODAL: {
                TITLE: 'History',
                BUTTONS: {
                    CLOSE: 'Close',
                },
            },
            COMMENTS_MODAL: {
                TITLE: 'Comments',
            },
            PRIORITIZE_MODAL: {
                TITLE: 'Prioritize',
            },
            COMPLETE_MODAL: {
                TITLE: 'Complete',
                DESCRIPTION:
                    'Are you sure you want to upgrade this prepped answer to a vetted prepped answer?',
                ERROR: 'Error upgrading to a vetted prepped answer',
                SUCCESS: 'Success upgrading to a vetted prepped answer',
                BUTTONS: {
                    COMPLETE: 'Complete',
                    CANCEL: 'Cancel',
                },
            },
            DECLINE_MODAL: {
                TITLE: 'Decline',
                DESCRIPTION: 'Are you sure you want to decline this vetted prepped answer request?',
                ERROR: 'Error declining vetted prepped answer request',
                SUCCESS: 'Success declining vetted prepped answer request',
                BUTTONS: {
                    DECLINE: 'Decline',
                    CANCEL: 'Cancel',
                },
            },
            DOWNGRADE_MODAL: {
                TITLE: 'Downgrade',
                ERROR: 'Error downgrading vetted prepped answer',
                SUCCESS: 'Success downgrading vetted prepped answer',
                DESCRIPTION: 'Are you sure you want to downgrade this vetted prepped answer?',
                BUTTONS: {
                    DOWNGRADE: 'Downgrade',
                    CANCEL: 'Cancel',
                },
            },
            DELETE_MODAL: {
                TITLE: 'Delete Prepped Answer',
                DESCRIPTION: 'Are you sure you want to delete this prepped answer?',
                SUCCESS: 'Success deleting prepped answer',
                ERROR: 'Error deleting prepped answer',
                BUTTONS: {
                    DELETE: 'Delete',
                    CANCEL: 'Cancel',
                },
            },
            SUGGEST_UPDATE: {
                BUTTONS: {
                    SUBMIT: 'Submit',
                    CANCEL: 'Cancel',
                },
                SUCCESS: 'Success suggesting vetted prepped answer update',
                ERROR: 'Error suggesting vetted prepped answer update',
            },
            UPDATE_REQUESTS_DIFF_MODAL: {
                ACCEPT_SUCCESS: 'Success accepting update request.',
                ACCEPT_ERROR: 'Error accepting update request.',
                DECLINE_SUCCESS: 'Success declining update request.',
                DECLINE_ERROR: 'Error declining update request.',
                SECTION_TITLE: 'Update Requests',
                TITLE: 'Update Request',
                EXPLANATION: 'Explanation',
                EXPLANATION_OF_CHANGES: 'Explanation of Changes',
                SUBMITTED: 'Submitted',
                REQUESTER: 'Requester',
                CONTENT: 'Content Links',
                VIEW: 'View',
                TOPICS: 'Topics',
                STATES: 'States',
                KEY_PHRASES: 'Key Phrases',
                TITLE_LABEL: 'Title',
                BODY: 'Body',
                CLOSE: 'Close',
            },
        },
    },
    ERROR: {
        STATUS: {
            NOT_FOUND: 'Request failed with status code 404',
        },
        MESSAGE: {
            NOT_AVAILABLE: 'Please contact us for assistance.',
            NOT_FOUND: 'Prepped Answer ${id} not found.',
        },
    },
    CREATE: {
        TITLE: {
            CREATE: 'Create New Prepped Answer',
            EDIT: 'Edit Prepped Answer',
        },
        NOTE: 'Please click Create when you are ready to create this record.',
        ERROR: 'Error creating new prepped answer',
        SUCCESS: 'Success creating new prepped answer',
        EDIT: 'Success editing new prepped answer',
        BUTTONS: {
            CANCEL: 'Cancel',
            CREATE: 'Create Record',
            EDIT: 'Save Changes',
        },
        FORM: {
            CONTENT_LINK: {
                PLACEHOLDER: 'Click here to search content...',
            },
            STATES: {
                PLACEHOLDER: 'Add a State',
            },
            TOPICS: {
                MAIN: {
                    PLACEHOLDER: 'Select Topic',
                },
                SUB: {
                    PLACEHOLDER: 'Select Sub Topic',
                },
                MICRO: {
                    PLACEHOLDER: 'Select Micro Topic',
                },
            },
        },
        CONTENT_LINK: {
            TITLE: 'Current Content Links:',
            DESCRIPTION: 'Are you sure you want to delete this content link?',
            BUTTONS: {
                CANCEL: 'Cancel',
                DELETE: 'Delete',
            },
        },
        PLACEHOLDER_TITLE: 'Available Placeholders',
        PLACEHOLDER_ITEMS: [
            {
                label: '{{ phone }}',
                description: 'Add Mineral phone number for client',
            },
            {
                label: '{{ user-first-name }}',
                description: "Add Client's First Name",
            },
            {
                label: '{{ user-full-name }}',
                description: "Add Client's Full Name",
            },
            {
                label: '{{ client-name }}',
                description: 'Add Client Company Display Name',
            },
            {
                label: '{{ partner-name }}',
                description: 'Add Partner Company Display Name',
            },
            {
                label: '{{ case-state }}',
                description: `Add Case's State(s) (e.g. "Alaska", "Alaska and Colorado", "Alaska, Colorado, and Delaware")`,
            },
            {
                label: '{{ my-name }}',
                description: 'Your Name: ${userFullName}',
            },
            {
                label: '{{ my-certifications }}',
                description: 'Your Certifications: ${hrAdvisorSignature}',
            },
        ],
        TOOLTIP_CONTENT: {
            COPY: 'Copy',
            COPIED: 'Copied',
        },
    },
    HISTORY: {
        TITLE: 'Prepped Answers History',
        END_OF_HISTORY: 'END OF HISTORY',
        NO_HISTORY: 'No History',
        MESSAGES: {
            NOMINATE_FOR_VPA: 'nominated for VPA',
            NOMINATE_COMPLETE: 'nomination was completed',
            NOMINATE_DECLINE: 'nomination was cancelled',
            NOMINATE_DOWNGRADE: 'Downgraded',
            NOMINATE_SUGGEST_UPDATE: 'suggested an update',
            NOMINATE_SUGGEST_UPDATE_ACCEPT: 'update was completed',
            NOMINATE_SUGGEST_UPDATE_DECLINE: 'update was cancelled',
        },
        CURRENT_STATE: {
            PENDING: 'pending',
            ACCEPTED: 'accepted',
            DECLINED: 'declined',
        },
        BUTTONS: {
            CLOSE: 'Close',
        },
    },
};

export const CREATE_MESSAGES = {
    TITLE: 'Create New Message',
    CONFIRMATION: {
        CANCEL: 'Cancel',
        CONFIRM: 'Confirm',
        DESCRIPTION: 'Are you sure you want to discard your unsaved edit?',
    },
    FORM: {
        CANCEL: 'Cancel',
        LABEL: 'FIND',
        PLACEHOLDER: 'Case No.',
        CREATE: 'Create Message',
        EDITOR_TITLE: 'Message',
        CASE_SEARCH_TITLE: 'Case Number',
    },
    ERRORS: {
        NOT_FOUND: 'Case not found.',
        SKU:
            'The case number searched does not meet the criteria for Partner View Messages. Please confirm this partner has the Partner View SKU.',
        SUBMIT: 'There was an error sending your message.',
    },
    SUCCESS:
        'This message has successfully been created. The Partner will be notified via email that they have a new message.',
};

export const VIEW_MESSAGE_TITLE = 'View Message';

export const MESSAGES = {
    BUTTONS: {
        VIEW: 'View',
    },
    LABEL: 'Messages',
    NO_DATA: 'You do not have any messages yet.',
    NO_SEARCH_RESULTS: 'No matching messages found.',
    SEARCH_PLACEHOLDER: 'Search by Case No., Partner, Client, Message, or From',
};

export const CASE_METRICS = {
    MY_RESOLVED_CASES: {
        TITLE: 'My Resolved Cases',
        TOOLTIP: 'Current day',
    },
    ALL_CASE_SUBMISSIONS: {
        TITLE: 'All Case Submissions',
        TOOLTIP: 'All cases submitted today',
    },
    ALL_OPEN_CASES: {
        TITLE: 'All Open Cases',
        TOOLTIP: 'All open cases, regardless of date created',
    },
    RESOLVED_CASES: {
        TITLE: 'Resolved Cases',
        TOOLTIP: 'All cases resolved today, regardless of Support/HR',
    },
    TITLE_HIDE: 'Hide Metrics',
    TITLE_SHOW: 'Show Metrics',
};

export const CASE_LIST_PAGINATION_RESET_STATE = {
    currentPage: 1,
    rowsPerPage: 10,
    totalRows: 0,
};

export const CASE_LIST_SETTINGS = {
    // How to specify URL / Redux Store persisted settings...
    /*
        // the name used for the URL parameter and the Component state
        defaultName: 'xxx',
        // specify for all EXTERNALLY_SUPPLIED
        // specify for INTERNALLY_SUPPLIED if not equal to an empty string
        defaultValue: {},
        // 
        title: 
        // specify if different from defaultName
        urlName: 'yyy',
        // specify when JSON.stringify() is needed when persisting
        // e.g. when the value is an object persisted to the URL
        // JSON.parse() will be used when "decoding" the stringified setting
        useJSON: true,
    */
    // settings provided to the component (via URL from other pages)
    EXTERNALLY_SUPPLIED: [
        {
            defaultName: 'assignedUserId',
            defaultValue: '',
            title: 'Results: "Assignee: ${assignedUserName} #${assignedUserId}"',
        },
        {
            defaultName: 'caseUserId',
            defaultValue: '',
            title: 'Results: "User: ${caseUserName} #${caseUserId}"',
        },
        {
            defaultName: 'clientCompanyId',
            defaultValue: '',
            title: 'Results: "Client Company: ${clientCompanyName} #${clientCompanyId}"',
        },
        {
            defaultName: 'parentCaseId',
            defaultValue: '',
            title: 'Results: "Child Cases for: #${parentCaseId}"',
        },
        {
            defaultName: 'partnerCompanyId',
            defaultValue: '',
            title: 'Results: "Partner Company: ${partnerCompanyName} #${partnerCompanyId}"',
        },
        {
            defaultName: 'relatedCaseId',
            defaultValue: '',
            title: 'Results: "Cases Related to: #${relatedCaseId}"',
        },
    ],
    // settings generated by the component (stored within this.state)
    INTERNALLY_SUPPLIED: [
        {
            defaultName: 'currentFilterSelections',
            defaultValue: {},
            urlName: 'filters',
            useJSON: true,
        },
        {
            defaultName: 'pagination',
            defaultValue: CASE_LIST_PAGINATION_RESET_STATE,
            useJSON: true,
        },
        { defaultName: 'savedSearchesValue' },
        { defaultName: 'searchSpec' },
        { defaultName: 'selectedSortOrder' },
    ],
};

export const CASE_LIST = {
    ASSIGNED_TO_ROLE_TYPE: 'mineral',
    BADGE_TEXT: {
        HIGH: 'High Priority',
        MEDIUM: 'Medium Priority',
        OBO_PRIVATE: 'OBO: Private',
        OBO_SHARED: 'OBO: Shared',
    },
    CONTACT_PREFERENCES: {
        PHONE: 'phone',
        TICKETING_SYSTEM: 'ticketing_system',
    },
    DEPARTMENTS: {
        ADVISORY_SERVICES: 'advisory services',
        CUSTOMER_SUPPORT: 'customer support',
        TECHNICAL_SUPPORT: 'technical support',
    },
    DUE_WITHIN_24_HOURS_TEXT: 'Due Within 24 Hours',
    FILTERS: {
        LABEL: 'Filters',
        RESET_LABEL: 'Clear All Filters',
    },
    ITEM_TITLES: {
        ASSIGNEE: 'ASSIGNEE',
        CASE_ID: 'CASE ID',
        CASE_TYPE: 'CASE TYPE',
        COMPANY_NAME: 'COMPANY NAME',
        CLOSED_DATE: 'CLOSED DATE',
        CREATED_DATE: 'CREATED DATE',
        DUE_DATE: 'DUE DATE',
        DUE_IN: 'DUE IN',
        PARTNER_NAME: 'PARTNER NAME',
        PARTNER_PHONE_NUMBER: 'PARTNER PHONE NUMBER',
        PAST_DUE: 'PAST DUE',
        PHONE_NUMBER: 'PHONE NUMBER',
        PREVIEW: 'PREVIEW',
        ROLE: 'ROLE',
        SOURCE: 'SOURCE',
        STATES: 'STATES',
        STATUS: 'STATUS',
        TOPICS: 'TOPICS',
        WHO_CASE_IS_FOR: 'USER NAME',
    },
    LAYOUTS: {
        HR_EXPERTS_AND_FRONTLINE_COORDINATORS: {
            assignee: true,
            caseId: true,
            caseType: true,
            closedDate: true,
            companyName: true,
            createdDate: true,
            dueDate: true,
            dueIn: true,
            partnerName: true,
            phoneNumber: true,
            preview: true,
            role: false,
            source: true,
            states: true,
            status: true,
            topics: true,
            whoCaseIsFor: true,
        },
        TECH_SUPPORT: {
            assignee: true,
            caseId: true,
            caseType: false,
            closedDate: true,
            companyName: false,
            createdDate: true,
            dueDate: true,
            dueIn: true,
            partnerName: false,
            phoneNumber: true,
            preview: true,
            role: true,
            source: true,
            states: false,
            status: true,
            topics: false,
            whoCaseIsFor: true,
        },
    },
    LAYOUT_SELECTIONS: [
        {
            label: 'Experts and Frontline',
            value: 'HR_EXPERTS_AND_FRONTLINE_COORDINATORS',
        },
        {
            label: 'Technical Support',
            value: 'TECH_SUPPORT',
        },
    ],
    LAYOUT_TYPES: {
        HR_EXPERTS_AND_FRONTLINE_COORDINATORS: 'HR_EXPERTS_AND_FRONTLINE_COORDINATORS',
        TECH_SUPPORT: 'TECH_SUPPORT',
    },
    MIN_CHARS_TO_SHOW_TOOLTIP: 14,
    OVERDUE_TEXT: 'Overdue',
    PAGINATION_RESULTS: {
        TITLE: 'TOTAL_NUMBER_OF_RESULTS Results',
        TITLE_SINGULAR: '1 Result',
    },
    PRIORITY_LEVELS: {
        HIGH: 'high',
        LOW: 'low',
        MEDIUM: 'medium',
    },
    SAVED_SEARCHES: {
        LABEL: 'Saved Searches',
        NAME: 'savedSearches',
        PLACEHOLDER: 'Custom',
        PRESET_OPTIONS: [
            { label: 'All Cases', value: 'allCases' },
            { label: 'All Open Cases', value: 'allOpenCases' },
            { label: 'Benefits', value: 'benefits' },
            {
                label: 'Cases Currently Assigned to Me',
                value: 'casesCurrentlyAssignedToMe',
            },
            {
                label: 'Cases with Future Tasks for Me',
                value: 'casesWithFutureTasksForMe',
            },
            {
                label: 'Cases with Completed Tasks by Me',
                value: 'casesWithCompletedTasksByMe',
            },
            { label: 'Employee Health & Safety', value: 'ehs' },
            { label: 'Unassigned Cases', value: 'unassignedCases' },
            { label: 'Unassigned PDE Cases', value: 'unassignedPDECases' },
        ],
        PRESET_VALUES: {
            ALL_CASES: 'allCases',
            ALL_OPEN_CASES: 'allOpenCases',
            BENEFITS: 'benefits',
            CASES_CURRENTLY_ASSIGNED_TO_ME: 'casesCurrentlyAssignedToMe',
            CASES_WITH_FUTURE_TASKS_FOR_ME: 'casesWithFutureTasksForMe',
            CASES_WITH_COMPLETED_TASKS_BY_ME: 'casesWithCompletedTasksByMe',
            CUSTOM: 'custom',
            EHS: 'ehs',
            UNASSIGNED_CASES: 'unassignedCases',
            UNASSIGNED_PDE_CASES: 'unassignedPDECases',
        },
        TITLE: 'Saved Search Results: "PRESET_OPTION_LABEL"',
        TITLE_WHEN_CUSTOM: 'Search Case Cave',
    },
    SEARCH: {
        LABEL: 'Search',
        NO_SEARCH_RESULTS: 'No matching cases found.',
        PLACEHOLDER: 'Search Case Cave',
    },
    SORT_SELECTIONS: [
        {
            label: 'Priority: High to Low',
            value: 'SORT_BY_PRIORITY_HIGH_TO_LOW',
        },
        {
            label: 'Deadline: Shortest to Longest',
            value: 'SORT_BY_DEADLINE',
        },
        {
            label: 'Created Date: Oldest to Newest',
            value: 'SORT_BY_CREATED_DATE_OLDEST_FIRST',
        },
        {
            label: 'Created Date: Newest to Oldest',
            value: 'SORT_BY_CREATED_DATE_NEWEST_FIRST',
        },
        {
            label: 'Closed Date: Newest to Oldest',
            value: 'SORT_BY_CLOSED_DATE_NEWEST_FIRST',
        },
    ],
    SORT_SELECTION_BEST_MATCH: {
        label: 'Best Match',
        value: 'SORT_BY_BEST_MATCH',
    },
    SORT_TYPES: {
        SORT_BY_PRIORITY_HIGH_TO_LOW: 'SORT_BY_PRIORITY_HIGH_TO_LOW',
        SORT_BY_DEADLINE: 'SORT_BY_DEADLINE',
        SORT_BY_CREATED_DATE_OLDEST_FIRST: 'SORT_BY_CREATED_DATE_OLDEST_FIRST',
        SORT_BY_CREATED_DATE_NEWEST_FIRST: 'SORT_BY_CREATED_DATE_NEWEST_FIRST',
        SORT_BY_CLOSED_DATE_NEWEST_FIRST: 'SORT_BY_CLOSED_DATE_NEWEST_FIRST',
    },
    VIEW_LINK_LABEL: 'View',
};

export const CASE_CONVERSATION = {
    CLOSED_STATUSES: ['cancelled', 'closed'],
    TITLE: 'Conversation',
    REPLY: {
        CANCEL: 'Cancel',
        INFO: 'Be mindful!',
        INFO_DETAILS: 'Once a conversation reply is submitted, it cannot be changed or deleted.',
        PLACEHOLDER_REPLY: 'Enter a reply or ask for more info...',
        PLACEHOLDER_START: 'Start a conversation or ask for more info...',
        SUBMIT: 'Submit',
        TITLE_REPLY: 'Reply to Conversation',
        TITLE_START: 'Start a Conversation',
    },
};

export const PARTNER_VIEW = {
    REPLY: {
        INFO_DETAILS: 'Once a message is submitted, it cannot be changed or deleted.',
    },
};

export const TOPICS = {
    PLACEHOLDER: 'Select a Topic',
    TITLE: 'Prepped Answer Topics',
    TOPIC_1: 'Topic 1',
    TOPIC_2: 'Topic 2',
    TOPIC_3: 'Topic 3',
};

export const CASE_STATES = {
    CANCELLED: 'cancelled',
    CLOSED: 'closed',
};

export const CASE_DETAILS = {
    TITLE: 'Case #${id}',
    ERRORS: {
        JIRA_URL: 'Must be a valid HTTPS URL',
        TASK_ERROR: 'Something went wrong, please try again.',
    },
    ACTIONS: {
        CANCEL_CASE: 'Cancel Case',
        LABEL: 'Actions',
        CREATE_CASE: 'Create a Case',
        RESEARCH: 'Research',
        SURVEY: 'View Survey',
        VIEW_ALL_PRODUCTS: 'View All Products',
        VIEW_CLIENT_COMPANY_CASES: 'View Client Company Cases',
        VIEW_PARTNER_COMPANY_CASES: 'View Partner Company Cases',
        VIEW_USER_CASES: 'View User Cases',
        VIEW_RELATED_CASES: 'View Related Cases',
    },
    MODALS: {
        SURVEY: {
            TITLE: 'Survey',
            CLOSE: 'Close',
        },
        CANCEL: {
            DESCRIPTION:
                'Are you sure you want to cancel this case? This action cannot be undone and unsaved changes will be lost.',
            EXIT: 'Exit',
            CONFIRM: 'Confirm',
        },
        QUESTION_ANSWER: {
            CANCEL: 'Cancel',
            CANCEL_CONFIRMATION: 'Are you sure you want to discard your unsaved edits?',
            CONFIRM: 'Confirm',
        },
        UNAUTHORIZED: {
            DESCRIPTION: 'You are not authorized to view this case',
        },
        URL_MODAL: {
            TITLE: 'URL',
            BUTTONS: {
                OK: 'Ok',
                CANCEL: 'Cancel',
            },
        },
    },
    BADGES: {
        PDE: 'PDE',
        DHE: 'DHE',
        BENEFITS: 'Benefits',
        EHS: 'Safety (EHS)',
        WHITELABEL: 'Whitelabel',
        OBO_PRIVATE: 'OBO: Private',
        OBO_SHARED: 'OBO: Shared',
        FIRST_CASE: 'First Case',
        SALES_DEMO: 'Sales Demo',
    },
    USER_SECTION: {
        EDIT_USER: 'Edit User',
        USER: 'USER',
        PHONE: 'PHONE',
        DIRECT: 'DIRECT',
        CELL: 'CELL PHONE',
        EMAIL: 'EMAIL',
        SUBMITTED_BY: 'SUBMITTED BY',
        BUTTONS: {
            SHOW_MORE: 'Show More',
            SHOW_LESS: 'Show Less',
        },
        CLIPBOARD_TOOLTIP_CONTENT: {
            COPY: 'Copy',
            COPIED: 'Copied',
        },
    },
    USER_DATA_LABELS: {
        COMPANY_EMPLOYEES: 'COMPANY EMPLOYEES',
        TITLE: 'User Details',
        USER: 'USER',
        CLIENT_COMPANY: 'CLIENT COMPANY',
        PARTNER_COMPANY: 'PARTNER COMPANY',
        CLIENT_EMPLOYEES: 'CLIENT EMPLOYEES',
        PLATFORM: 'PLATFORM',
        EMAIL: 'EMAIL',
        PARTNER_EMAIL: 'PARTNER EMAIL',
        PHONE: 'PHONE',
        PARTNER_PHONE: 'PARTNER PHONE',
        DIRECT_PHONE: 'DIRECT',
        PARTNER_DIRECT_PHONE: 'PARTNER DIRECT',
        CELL_PHONE: 'CELL PHONE',
        PARTNER_CELL_PHONE: 'PARTNER CELL PHONE',
        CASES_NINETY: 'CASES IN 90 DAYS',
        MEMBER_SINCE: 'MEMBER SINCE',
        ROLE: 'ROLE',
        ACCOUNT_MANAGER: 'ACCOUNT MANAGER',
        PREMIUM_SKU: 'PREMIUM PRODUCT AVAILABILITY',
    },
    CASE_DATA_LABELS: {
        TITLE: 'Case Details',
        YES: 'Yes',
        NO: 'No',
        BROWSER: 'BROWSER',
        BROWSER_VERSION: 'BROWSER VERSION',
        JIRA_URL: 'JIRA URL',
        CONTACT_PREFERENCE: 'CONTACT PREFERENCE',
        PARTNER_SUBMITTED: 'SUBMITTED BY PARTNER?',
        SHARE_WITH_CLIENT: 'SHARE RESPONSE WITH CLIENT?',
        STATUS: 'STATUS',
        SOURCE: 'SOURCE',
        PRIORITY: 'PRIORITY',
        CASE_EMPLOYEES: 'CASE EMPLOYEES',
        TOPICS: 'TOPICS',
        TYPE: 'CASE TYPE',
        OUT_OF_SCOPE: 'OUT OF SCOPE?',
        IMMEDIATE_TRANSFER: 'IMMEDIATE TRANSFER?',
        PARTNER_CONTACT: 'PARTNER CONTACT',
        CONTACT_PREFERENCES: {
            PHONE: 'Phone',
            CASE_CAVE: 'Case Cave',
        },
    },
    CASE_LOCATIONS: {
        CANCEL_TEXT: 'Cancel',
        EDIT_TEXT: 'Edit Case States',
        HEADER_TITLE: 'States',
        PRIMARY_STATE_FOOTNOTE: '* The primary state for your company is ${primaryStateName}.',
        PRIMARY_STATE_INDICATOR: '(Primary)',
        PRIMARY_STATE_NONE_SELECTED: '(none selected)',
        RESET_TEXT: 'Reset',
        SAVE_TEXT: 'Save Case States',
    },
    BUTTONS: {
        EDIT_USER: 'Edit User',
        EDIT_CASE_DETAILS: 'Edit Case Details',
        EDIT_COMPANY: 'Edit Company',
        VIEW_ALL_PRODUCTS: 'View All Products',
    },
    All_PRODUCT_MODAL: {
        TITLE: 'Products Available to',
        CONFIGURATIONS: 'Configurations',
        ACTIVE_SKU: 'SKUs',
        PLACEHOLDER: 'Search by name',
        EHS_PRODUCTS: {
            TITLE: 'EHS Content',
            ACTIVE_PACKAGES: 'Active Packages',
            NO_ACTIVE_PACKAGES: '${COMPANY_NAME} does not have EHS Packages.',
            ACTIVE_SKU: 'Active SKUs',
            NO_ACTIVE_SKU: '${COMPANY_NAME} does not have EHS SKUs.',
        },
        NO_SEARCH_RESULTS: 'No matching messages found.',
        BUTTONS: {
            OK: 'OK',
        },
    },
    TABS: {
        QUESTION_ANSWER: {
            label: 'Question & Answer',
            value: 'questionAnswer',
        },
        PARENT_CASE: {
            label: 'Parent Case',
            value: 'parentCase',
        },
        RESOURCES: {
            label: 'Resources',
            value: 'resources',
        },
        PARTNER_VIEW: {
            label: 'Partner-View Messages',
            value: 'partnerViewMessages',
        },
    },
    QUESTION: {
        AUTOSAVE_TEXT: 'You have an unsaved question.  ',
        EDIT_BUTTONS: {
            SAVE: 'Save changes',
            CANCEL: 'Cancel',
        },
        EDIT_QUESTION: 'Edit Question',
        FIELD_KEY: 'CASE_QUESTION_FIELD',
        FROM: 'From ${user}, ${date}.',
        TITLE: 'Question',
    },
    ANSWER: {
        ADD_ANSWER: 'Add Answer',
        ADD_PREPPED_ANSWER: 'Add Prepped Answer',
        AUTOSAVE_TEXT: 'You have an unsaved answer.  ',
        EDIT_ANSWER: 'Edit Answer',
        FIELD_KEY: 'CASE_ANSWER_FIELD',
        FROM: 'From ${user}, ${date}.',
        TITLE: 'Answer',
    },
    ATTACHMENTS: {
        TITLE: 'Attachments',
        CLIENT_ATTACHMENTS: 'CLIENT ATTACHMENTS',
        EXPERT_ATTACHMENTS: 'EXPERT ATTACHMENTS',
        ADD_CLIENT_ATTACHMENT: 'Add Client Attachment',
        ADD_EXPERT_ATTACHMENT: 'Add Expert Attachment',
        DOWNLOAD: 'Download',
        DELETE: 'Delete',
        DELETED: 'Deleted',
        VIEW: 'View',
        ADDED: 'Added ${date}',
        TYPE: {
            CLIENT: 'client',
            EXPERT: 'expert',
        },
    },
    CASE_LOG: {
        TITLE: 'Case Log',
        TABS: {
            TASKS: {
                label: 'Tasks',
                value: 'tasks',
            },
            HISTORY: {
                label: 'History',
                value: 'history',
            },
            COMMENTS: {
                label: 'Comments',
                value: 'comments',
            },
        },
        COMMENTS_TABS: {
            CASE: {
                label: 'Case',
                value: 'case',
            },
            CLIENT: {
                label: 'Client',
                value: 'client',
            },
            PARTNER: {
                label: 'Partner',
                value: 'partner',
            },
        },
        TASKS: {
            ACTIONS: 'ACTIONS',
            ADD_TASK: 'Add Task',
            ACCEPT_TASK: 'Accept Task',
            ACTIVATE_TASK: 'Activate Task',
            ASSIGN: 'Assign',
            ASSIGN_TO_ME: 'Assign To Me',
            ASSIGN_MODAL_TITLE: 'Assigning ${taskName} Task',
            ASSIGNED_BY: 'Assigned by ${taskAssignerName}',
            ASSIGNED_AND_CREATED: 'Created & Assigned by ${name}',
            CHANGE_DEADLINE: 'Change Deadline',
            CLEAR_DEADLINE: 'Clear Deadline',
            CLOSE_CASE: 'Close Case',
            COMPLETE_TASK: 'Complete Task',
            CONFIRM: 'Are you sure you want to delete this task?',
            CREATED_BY: 'Created by ${taskCreatorName}',
            CURRENT_TASK: 'Current Task',
            DEADLINE_SELECTED: 'Deadline Selected: ${deadline}',
            DELETE_TASK: 'Delete Task',
            DUE: 'Due ${dueDate}',
            ERRORS: {
                NO_ANSWER:
                    'An answer is required to complete the Answer task. Please add an answer.',
                NO_ANSWER_TASK:
                    'A completed answer task is required to close a case. Please complete an answer task.',
                EDITING_ANSWER:
                    'The answer has not been saved. Please save the answer before completing the Answer task.',
            },
            FUTURE_TASKS: '${futureTaskCount} Future Tasks',
            MOVE: 'MOVE',
            ONE_FUTURE_TASK: '1 Future Task',
            NO_DEADLINE_SELECTED: 'No Deadline Selected',
            REOPEN_CASE: 'Reopen Case',
            REASSIGN: 'Reassign',
            REASSIGN_TO_ME: 'Reassign To Me',
            SAVE: 'Save',
            TASK_TEXT: '${taskUserName} > ${taskName}',
            TASK_STATES: {
                ACTIVE: 'active',
                ACCEPTED: 'accepted',
                PENDING: 'pending',
                ASSIGNED: 'assigned',
            },
            TASK_TYPES: {
                ANSWER: 'Answer',
                CLOSE: 'Close',
                CONTACT_AFFILIATE: 'Contact Affiliate',
                CALL_CLIENT: 'Call Client',
                CLIENT_FOLLOWUP: 'Waiting for Client Followup',
                CONSULT: 'Waiting for Consult',
            },
            TOPIC_CTA: '*At least 1 topic selection is required before closing a case.',
            UNASSIGN: 'Unassign',
            UNASSIGNED: 'Unassigned',
        },
        HISTORY: {
            END_OF_HISTORY: 'END OF HISTORY',
            NO_HISTORY: 'No History',
            CASE_STATUS: {
                CASE_CREATED: 'Created via ${value} ${byUserName}',
                STATUS_CHANGED: 'Status Changed to: ${newValue} ${byUserName}',
                CASE_ANSWER_CHANGED: 'Answer changed during review ${byUserName}',
                TASK_COMPLETED: 'Completed task: ${taskType} ${byUserName}',
                CASE_TYPE_CHANGED:
                    'Case Type changed from ${oldValue} to ${newValue} ${byUserName}',
                CASE_TRANSFERRED:
                    'Case transferred from ${fromUsername} to ${toUserName} ${byUserName}',
                TASK_CANCELLED: 'Cancelled task: ${taskType} ${byUserName}',
                AGO: 'AGO',
            },
            HISTORY_EVENTS: {
                CASE_CREATE: 'ticket_create',
                STATUS_CHANGE: 'status_change',
                CASE_ANSWER_CHANGE: 'ticket_answer_change',
                TASK_COMPLETE: 'task_complete',
                CASE_TYPE_CHANGE: 'ticket_type_change',
                CASE_TRANSFER: 'ticket_transfer',
                TASK_CANCEL: 'task_cancel',
            },
            BUTTONS: {
                SHOW_MORE: 'Show More',
                SHOW_LESS: 'Show Less',
            },
            CASE_ANSWER_CHANGE_MODAL: {
                TITLE: 'Case Answer Change',
                BUTTON: {
                    CLOSE: 'Close',
                },
            },
        },
    },
    USE_PREPPED_ANSWERS_MODAL: {
        CLOSE: 'Close',
        DETAILS_TITLE: 'Prepped Answer Details',
        REUSE: 'Reuse',
        TITLE: 'Add Prepped Answer',
        USE: 'Use',
    },
    EDIT_CASE_MODAL: {
        TITLE: 'Edit Case Details',
        CANCEL: 'Cancel',
        SAVE_CHANGES: 'Save Changes',
        JIRA_URL: 'Jira URL',
        BROWSER: 'Browser',
        BROWSER_VERSION: 'Browser Version',
        TOPICS: {
            TITLE: 'Topics',
            DESCRIPTION: 'Add up to 3 topics. 1 is required.',
        },
        STATES: 'States',
        MESSAGES: {
            SUCCESS: 'Success updating case details',
            ERROR: 'Error updating case details',
        },
    },
    FOLLOW_UP_CASES: {
        PARENT_CASE: 'Parent Case: See (${followUpCaseCount}) Child Cases',
        CHILD_TICKET: 'Child Case:',
        SEE: 'See',
        PARENT_CASE_TITLE: 'Parent Case',
    },
    CASE_OVERWRITE_ANSWER: {
        DESCRIPTION:
            'The Answer for this case has been updated since you started editing it. The updates are shown below. If you save, you will overwrite these updates. Do you wish to Save your changes, or Cancel and return to editing so you can incorporate these updates into your own?',
        UPDATED_BY: 'Updated By ${username} at ${time}',
        BUTTONS: {
            SAVE: 'Save & Overwrite',
            CANCEL: 'Cancel & Return to Editing',
        },
        TOOLTIP_CONTENT: {
            COPY: 'Copy',
            COPIED: 'Copied',
        },
    },
    CASE_RESOURCES: {
        RESOURCES_USED: {
            title: 'Resources Used',
        },
        PA_LINKS_USED: {
            title: 'Prepped Answers Used by This Case',
        },
        PA_RESOURCES_USED: {
            title: 'Prepped Answer Resources Used by This Case',
        },
        BUTTONS: {
            ADD_RESOURCE: 'Add Resource',
        },
    },
    PLACEHOLDER_ITEMS: {
        PHONE: '{{ phone }}',
        USER_FIRST_NAME: '{{ user-first-name }}',
        USER_FIRST_NAME_LEGACY: '{{ user-name }}',
        USER_FULL_NAME: '{{ user-full-name }}',
        CLIENT_DISPLAY_NAME: '{{ client-name }}',
        CLIENT_DISPLAY_NAME_LEGACY: '{{ client-company }}',
        PARTNER_DISPLAY_NAME: '{{ partner-name }}',
        CASE_STATE: '{{ case-state }}',
        CASE_STATE_LEGACY: '{{ ticket-state }}',
        MY_NAME: '{{ my-name }}',
        MY_CERTIFICATES: '{{ my-certifications }}',
    },
    ADD_PREPPED_ANSWER: {
        BUTTONS: {
            ADD: 'Add Prepped Answer',
        },
        NO_DATA: 'No Favorite ${type}s',
        TYPES: {
            ANSWER: {
                button: 'Add Answer',
                link: 'View All Answers',
                value: 'answer',
            },
            SALUTATION: {
                button: 'Add Salutation',
                link: 'View All Salutations',
                value: 'salutation',
            },
            SIGNATURE: {
                button: 'Add Signature',
                link: 'View All Signatures',
                value: 'signature',
            },
        },
    },
    SAVE_PREPPED_ANSWER: {
        SAVE: 'Save Prepped Answer',
        LINK: 'View Prepped Answer #${savedPreppedAnswerId}',
    },
    AUTO_SAVE: {
        DEFAULT_TIMER: 200,
    },
};

export const PARTNER_VIEW_MESSAGES = {
    AUTOSAVE_TEXT: 'You have an unsaved message.  ',
    CREATE_PARTNER_VIEW_MESSAGE_TITLE:
        'Add a Message to all Partner Administrators of ${partnerCompany}',
    LOAD_ERROR:
        'Partner-View Messages could not be loaded. Please refresh the page to view this information.',
    NO_MESSAGES_FOUND: 'There are no Partner-View Messages for this Case...',
    SKU_KEY: 'hrconnect',
    USER_DATA_TITLES: {
        CLIENT_COMPANY: 'CLIENT COMPANY',
        PARTNER_COMPANY: 'PARTNER COMPANY',
        USER: 'USER',
    },
};

export const CASE_ROUTES = {
    TYPE: {
        FOLLOW_UP_CASE: 'FOLLOW_UP_CASE',
        MEETING: 'MEETING',
        USER_LOOKUP_CASE: 'USER_LOOKUP_CASE',
        UNKNOWN_CASE: 'UNKNOWN_CASE',
        NEW_CASE: 'CREATE_NEW_CASE',
    },
    CREATE_NEW_CASE: {
        TITLE: 'Create New Case',
    },
    ERROR: 'You must select a user to create a case.',
    ERROR_ROUTE_TYPE: 'The provided case type was not recognized.',
};

export const CASE_CREATE = {
    BUTTONS: {
        SAVE: 'Create a Case',
        CANCEL: 'Cancel',
    },
    CANCEL: 'Are you sure you want to cancel this case?',
    RECAP_CASE_LABELS: {
        TITLE:
            'This case is a recap of the meeting between ${hostName} and ${inviteeName} on ${meetingTime}.',
    },
    UNKNOWN_CASE_LABELS: {
        TITLE: 'This case is being converted from unknown case: ${unknownCaseId}',
    },
    USER_DETAILS_LABELS: {
        TITLE: 'User Details',
    },
    CREATE_FOLLOW_UP_LABELS: {
        TITLE: 'This case is a followup to parent case: ${caseId}',
    },
    CASE_DETAILS_LABELS: {
        TITLE: 'Enter Case Details',
        CASE_SETTINGS: {
            TITLE: 'Case Settings',
        },
        TOPICS: {
            TITLE: 'Topics',
        },
        QUESTION: {
            TITLE: 'Question',
        },
        ANSWER: {
            TITLE: 'Answer',
        },
        STATES: {
            TITLE: 'States',
            SUBTITLES: {
                ADD_TITLE: 'Add Applicable States',
                EDIT_TITLE: 'Edit Applicable States',
            },
            CASE_STATES: 'Case States',
            COMPANY_PROFILE_STATES: 'Company Profile States',
            ADD_ALL_STATES: 'Add All States',
            REMOVE_ALL_STATES: 'Remove All States',
            ERROR: {
                REQUIRED: 'A case must have at least one location',
            },
        },
        CONTENT_LINKS: {
            ADD_LINKS: 'Add Link',
            NONE: 'None',
            TITLE: 'Content',
            PLACEHOLDER: 'Click here to search content...',
            DESCRIPTION: 'Are you sure you want to delete this content link?',
            BUTTONS: {
                CANCEL: 'Cancel',
                DELETE: 'Delete',
            },
        },
        ATTACHMENTS: {
            TITLE: 'ATTACHMENTS',
        },
    },
};

export const AUTOSAVE = {
    DISCARD: 'Click here to discard your unsaved edits.',
    CONFIRMATION_MESSAGE: 'Are you sure you want to discard your unsaved edits?',
    CANCEL: 'Cancel',
    CONFIRM: 'Confirm',
};

export const CASE_PREMIUM_SKU_MENU = {
    PREMIUM_SKUS: [
        {
            key: 'consultativeservices',
            name: 'Dedicated HR Expert',
        },
        {
            key: 'ehsclientbasic',
            name: 'EHS Client Basic',
            ehsSKU: true,
        },
        {
            key: 'ehsclientpremium',
            name: 'EHS Client Premium',
            ehsSKU: true,
        },
        {
            key: 'ehscosmic',
            name: 'EHS Cosmic',
            ehsSKU: true,
        },
        {
            key: 'ehspartner',
            name: 'EHS Partner',
            ehsSKU: true,
        },
        {
            key: 'handbooks',
            name: 'Smart Employee Handbook Plus',
        },
        {
            key: 'esignature',
            name: 'eSignature',
            handbookPlusSKU: true,
        },
        {
            key: 'handbookslocalpolicies',
            name: 'Smart Employee Handbooks Local Policies',
            handbookPlusSKU: true,
        },
        {
            key: 'handbooksmultistate',
            name: 'Smart Employee Handbooks Multi State',
            handbookPlusSKU: true,
        },
        {
            key: 'handbooks.spanish',
            name: 'Spanish language handbooks',
            handbookPlusSKU: true,
        },
        {
            key: 'premium',
            name: 'Upsell',
        },
        {
            key: 'learnpackagenysharassment',
            name: 'Workplace Harassment Prevention',
        },
        {
            key: 'anonreporting',
            name: 'Anonymous Reporting',
        },
    ],
    APPLIED_STYLE: {
        NORMAL: 'normal',
        STRIKE_THROUGH: 'strikethrough',
        CHECK_MARK: 'checkmark',
    },
};
